var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.modalTitle,
        width: "520px",
        "ok-button-props": {
          props: { loading: _vm.uploading, disabled: _vm.fileList.length === 0 }
        }
      },
      on: { ok: _vm.handleUpload, cancel: _vm.handleClose }
    },
    [
      _c(
        "a-upload-dragger",
        {
          attrs: {
            multiple: false,
            accept: _vm.ALLOWED_FILE_EXTENSIONS.join(","),
            "file-list": _vm.fileList,
            "before-upload": _vm.beforeUpload
          },
          on: { change: _vm.handleChange }
        },
        [
          _c(
            "p",
            { staticClass: "ant-upload-drag-icon" },
            [_c("a-icon", { attrs: { type: "inbox" } })],
            1
          ),
          _c("p", { staticClass: "ant-upload-text" }, [
            _vm._v(_vm._s(_vm.$t("lbl_upload_drag_and_drop")))
          ]),
          _c("p", { staticClass: "ant-upload-hint" }, [
            _vm._v(_vm._s(_vm.$t("lbl_upload_info_4")))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }